import {mapGetters} from "vuex";
import {copyObject, generateProductConfigSteps, resetConfigurationStep} from "../libraries/utils";
import ProductSelection from "../domains2/orders/ProductSelection";

export default {

	computed: {
		...mapGetters([
			"productCatalog",
			"selections",
			"tenantSettings",
			"cachedPickupRules",
			"globalSelectedShop",
			"cartProducts"
		])
	},
	methods: {
		async goToConfigurationStep({item, baseProductId}) {
			resetConfigurationStep(this);
			const configurationSteps = generateProductConfigSteps(item);
			if(configurationSteps.length > 0) {
				this.$router.push({
					name: "productDetailsConfiguration",
					params: {
						item: item,
						type: configurationSteps[0].toLowerCase(),
						productId: item.product.id,
						baseProductId,
						dialogCategory: "LARGE_MENU_UPGRADE",
						productSelectionId: item.productSelections[item.productSelections.length - 1].productSelectionId
					}
				});
			}
		},
		findOrCreateProductSelection(id) {
			if (this.cartProducts) {
				const productSelections = this.selections.filter(p => p.productId === id);
				if (productSelections) {
					return copyObject(productSelections);
				}
				return [ProductSelection.createFromProduct(this.productCatalog.getProduct(id, true))];
			}
			return [];
		},
		createCompositeSelectedProducts(item) {
			const productSelection = ProductSelection.createFromProduct(item.product);
			ProductSelection.ChangeQuantity(productSelection, item.product, 1);
			// prepare selected products for adding whole product selection instead of just an id
			const productGroup = this.productCatalog.getProduct(productSelection.productId, true).groups.find(g => g.appearance === "single");
			const groups = productSelection.groups.find(g => {
				if (productGroup) {
					return g.groupId === productGroup.id;
				} else {
					return false;
				}
			});
			if (groups) {
				const selectedProducts = productSelection.groups
					.find(g => g.groupId === productGroup.id).selectedProducts;
				const productId = selectedProducts[0];
				selectedProducts.splice(selectedProducts.indexOf(productId), 1);
				const productsGroupsWithDefaultSelected = productSelection.groups
					.filter(g => g.options.defaultSelected && g.appearance !== "single");
				for(const productGroupsWithDefaultSelected of productsGroupsWithDefaultSelected) {
					const mainGroupProduct = this.productCatalog.getProduct(productGroupsWithDefaultSelected.selectedProducts[0]);
					const groupProductSelection = ProductSelection.createFromProduct(mainGroupProduct);
					// if main group product has groups/configurations we should enrich the product selection for it
					if(groupProductSelection.groups.length || groupProductSelection.configurations.length) {
						const selectedProducts = productSelection.groups
							.find(g => g.groupId === productGroupsWithDefaultSelected.groupId).selectedProducts;
						const productId = selectedProducts[0];
						selectedProducts.splice(selectedProducts.indexOf(productId), 1);
						selectedProducts.push({
							productId: mainGroupProduct.id,
							groups: groupProductSelection.groups.map(g => {
								return {
									groupId: g.id,
									selectedProducts: []
								};
							}),
							configurations: [...mainGroupProduct.configurations
								.filter(config => config.appearance === "checklist").map(config => {
									const selectedValue = config.options.defaultSelectedArray ? config.options.defaultSelectedArray : [];
									return {
										configurationId: config.id,
										selectedValue: selectedValue
									};
								})]
						});
					}
				}
				const product = this.productCatalog.getProduct(productId, true);
				selectedProducts.push({
					"productId": product.id,
					"groups": product.groups.map(g => {
						return {
							groupId: g.id,
							selectedProducts: []
						};
					}),
					"configurations": [...this.productCatalog.getProduct(product.id, true).configurations
						.filter(config => config.appearance === "checklist").map(config => {
							const selectedValue = config.options.defaultSelectedArray ? config.options.defaultSelectedArray : [];
							return {
								configurationId: config.id,
								selectedValue: selectedValue
							};
						})]
				});
			}
			return productSelection;
		}
	}
};
